import { eMode } from "../../../content/enum";
import { IDmMucThuNienCheCopyRequest } from "../../../model/request/category/dmMucThuNienCheRequest";
import { IDmMucThuNienCheActionTypes } from "../../action-types/category/IDmMucThuNienCheActions";
import { IDmMucThuNienCheReducer } from "../../reducer-model/category/IDmMucThuNienCheReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmMucThuNienCheReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucThuNienChes: [],
  modeEdit: eMode.xem,
  expandedKeys: [],
  sinhVienApDungs: [],
  isShowModalApDung: false,
  isDangTaiXemTruoc: false,
  isDangApDung: false,
  idBangGiaDangAps: [],
  processId: "",
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    search_key: undefined,
    id_khoi_nganh: 0,
    id_doi_tuong: 0,
    dot_tuyen_sinh: 0,
    // Niên chế không tách chuyên ngành chính / song ngành ⇒ luôn lấy tất cả.
    hinh_thuc_dao_tao: "all",
  },
};

export const mucThuNienCheReducer = (
  state: IDmMucThuNienCheReducer = iniState,
  action: IDmMucThuNienCheActionTypes,
): IDmMucThuNienCheReducer => {
  switch (action.type) {
    case "MUC_THU_NIEN_CHE_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "MUC_THU_NIEN_CHE_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuNienChes: action.payload,
      };
    case "MUC_THU_NIEN_CHE_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_THU_NIEN_CHE_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_THU_NIEN_CHE_SAVE_SUCCESS": {
      // Dòng vừa lưu thay cho dòng cũ CÙNG TỌA ĐỘ (phạm vi × khoản), không chỉ cùng id:
      // ô mới tạo gửi lên id = 0 nên so theo id sẽ để lại bản sao cũ trên lưới.
      const khoa = (x: any) =>
        `${x.id_he}-${x.khoa_hoc}-${x.id_nganh}-${x.id_chuyen_nganh}-${x.id_lop}` +
        `-${x.id_doi_tuong}-${x.id_khoi_nganh}-${x.id_quoc_tich}-${x.dot_tuyen_sinh}` +
        `-${x.nganh2}-${x.id_thu_chi}-${x.hoc_ky}-${x.nam_hoc}`;
      const khoaMoi = new Set(action.payload.map(khoa));
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuNienChes: [
          ...state.mucThuNienChes.filter((x) => !khoaMoi.has(khoa(x))),
          ...action.payload.filter((x) => x.so_tien >= 0),
        ],
      };
    }
    case "MUC_THU_NIEN_CHE_SAVE_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_THU_NIEN_CHE_UPDATE_STATUS":
      return { ...state, status: action.payload };
    case "MUC_THU_NIEN_CHE_CHANGE_REQUEST":
      return { ...state, request: action.payload };

    case "MUC_THU_NIEN_CHE_LOCK_START":
      return {
        ...state,
        request: action.payload,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_NIEN_CHE_LOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuNienChes: action.payload,
      };
    case "MUC_THU_NIEN_CHE_LOCK_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_THU_NIEN_CHE_UNLOCK_START":
      return {
        ...state,
        request: action.payload,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_NIEN_CHE_UNLOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuNienChes: action.payload,
      };
    case "MUC_THU_NIEN_CHE_UNLOCK_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_THU_NIEN_CHE_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowModalCopy: action.payload,
        requestCopy: {} as IDmMucThuNienCheCopyRequest,
      };
    case "MUC_THU_NIEN_CHE_COPY_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_THU_NIEN_CHE_COPY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucThuNienChes: action.payload,
        isShowModalCopy: false,
      };
    case "MUC_THU_NIEN_CHE_COPY_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_THU_NIEN_CHE_CHANGE_MODE_EDIT":
      return { ...state, modeEdit: action.payload };
    case "MUC_THU_NIEN_CHE_CHANGE_EXPANDED_KEYS":
      return { ...state, expandedKeys: action.payload };

    case "MUC_THU_NIEN_CHE_PREVIEW_START":
      return {
        ...state,
        isDangTaiXemTruoc: true,
        idBangGiaDangAps: action.payload.ids,
      };
    case "MUC_THU_NIEN_CHE_PREVIEW_SUCCESS":
      return {
        ...state,
        isDangTaiXemTruoc: false,
        sinhVienApDungs: action.payload,
        isShowModalApDung: true,
      };
    case "MUC_THU_NIEN_CHE_PREVIEW_ERROR":
      return { ...state, isDangTaiXemTruoc: false };

    case "MUC_THU_NIEN_CHE_DONG_MODAL_AP_DUNG":
      return {
        ...state,
        isShowModalApDung: false,
        sinhVienApDungs: [],
        idBangGiaDangAps: [],
      };

    case "MUC_THU_NIEN_CHE_AP_DUNG_START":
      return {
        ...state,
        isDangApDung: true,
        processId: action.payload.process_id ?? "",
      };
    case "MUC_THU_NIEN_CHE_AP_DUNG_SUCCESS":
      return {
        ...state,
        isDangApDung: false,
        isShowModalApDung: false,
        sinhVienApDungs: [],
        idBangGiaDangAps: [],
      };
    case "MUC_THU_NIEN_CHE_AP_DUNG_ERROR":
      return { ...state, isDangApDung: false, processId: "" };

    case "MUC_THU_NIEN_CHE_DONG_PROCESS":
      return { ...state, processId: "" };

    default:
      return state;
  }
};
